module.exports = __webpack_public_path__ + "img/part1-dIcon5.cdce69a8.png";